import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AddressModel } from '../../../../shared/models/address.model';

@Component({
    selector: 'account-orders-details-shipping-address',
    templateUrl: './account.orders.details.shipping-address.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsShippingAddressComponent {
    @Input('address') address: AddressModel;
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/orders/details/shipping-address/account.orders.details.shipping-address.component.ts